@if(service.viewDroplistItems.length){
<div class='experience-scheduling-views-part'>

	@if(service.selectedViewItem(); as selectedViewItem){

	<droplist class="views-droplist" [items]='service.viewDroplistItems' [selectedItem]='selectedViewItem'
		(selectionChange)='service.onViewDroplistChange($event)' [filterable]='false' [navigation]='true'
		sortBy='customSort' style='display:inline-block'>
	</droplist>

	@switch (selectedViewItem.uniqueId) {
	@case (service.viewId.CurriculumSchedules) {
	<experience-schedules-curriculum-schedules-view-part></experience-schedules-curriculum-schedules-view-part>
	}
	@case (service.viewId.AcceleratorCourseAssignments) {
	<experience-scheduling-accelerator-course-assignments-view-part></experience-scheduling-accelerator-course-assignments-view-part>
	}
	}
	}

</div>
}